(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.dsm = {}));
})(this, (function (exports) { 'use strict';

  var radii$1 = {
  	"v-none": "0px",
  	"v-xs": "2px",
  	"v-sm": "4px",
  	"v-md": "6px",
  	"v-lg": "8px",
  	"v-xl": "16px",
  	"v-full": "9999px"
  };

  var neutral = {
  	"100": "#253136",
  	"200": "#2d3b41",
  	"300": "#404d53",
  	"400": "#545f64",
  	"500": "#717a7f",
  	"600": "#888f93",
  	"700": "#a0a7a9",
  	"800": "#c4c7c9",
  	"900": "#e5e6e7",
  	"1000": "#ffffff",
  	"050": "#171e21",
  	"025": "#0F1315",
  	"000": "#050606"
  };
  var spring = {
  	"100": "#97ead5",
  	"200": "#60dfbf",
  	"300": "#19bd94",
  	"400": "#0ea37d",
  	"500": "#068262",
  	"600": "#056c52",
  	"700": "#045642",
  	"800": "#033c2e",
  	"900": "#02221a",
  	"050": "#cef5ec",
  	"025": "#f1fcf9"
  };
  var teal = {
  	"100": "#bde0dc",
  	"200": "#a9d2cf",
  	"300": "#78b1b2",
  	"400": "#569b9e",
  	"500": "#1b7e85",
  	"600": "#1d686e",
  	"700": "#1c5358",
  	"800": "#19393c",
  	"900": "#121f21",
  	"050": "#def1ee",
  	"025": "#f7fcfb"
  };
  var tan = {
  	"100": "#ded9d4",
  	"200": "#cfc8c3",
  	"300": "#b0a5a0",
  	"400": "#9b8d88",
  	"500": "#816e69",
  	"600": "#6f5a55",
  	"700": "#5e4742",
  	"800": "#482d28",
  	"900": "#2a1916",
  	"050": "#efede8",
  	"025": "#fbfaf9"
  };
  var purple = {
  	"100": "#d8d8ea",
  	"200": "#c7c8e1",
  	"300": "#a2a4cd",
  	"400": "#8a8bc0",
  	"500": "#696caf",
  	"600": "#55589e",
  	"700": "#44467f",
  	"800": "#2f3158",
  	"900": "#1b1b32",
  	"050": "#ececf5",
  	"025": "#fafafc"
  };
  var orange = {
  	"100": "#f8d2c0",
  	"200": "#f5bda3",
  	"300": "#ee8f62",
  	"400": "#e26f38",
  	"500": "#b85526",
  	"600": "#974823",
  	"700": "#793a1c",
  	"800": "#542813",
  	"900": "#2f170b",
  	"050": "#fcebe3",
  	"025": "#fef9f7"
  };
  var blue = {
  	"100": "#cfdce7",
  	"200": "#b8ccdc",
  	"300": "#8babc6",
  	"400": "#6c94b7",
  	"500": "#4276a2",
  	"600": "#2e628f",
  	"700": "#244f73",
  	"800": "#19374f",
  	"900": "#0e1e2c",
  	"050": "#e8eff4",
  	"025": "#f9fbfc"
  };
  var green = {
  	"100": "#c0e0d8",
  	"200": "#a6d3c7",
  	"300": "#69b5a2",
  	"400": "#3e9f87",
  	"500": "#068262",
  	"600": "#056c52",
  	"700": "#045642",
  	"800": "#033c2e",
  	"900": "#02221a",
  	"050": "#e1f0ec",
  	"025": "#f7fbfa"
  };
  var yellow = {
  	"100": "#f5d68e",
  	"200": "#f3c367",
  	"300": "#d69d3f",
  	"400": "#b88738",
  	"500": "#926b2f",
  	"600": "#795929",
  	"700": "#604722",
  	"800": "#42321a",
  	"900": "#241c11",
  	"050": "#fbedc1",
  	"025": "#fffbe9"
  };
  var red = {
  	"100": "#fbcfcf",
  	"200": "#f8bbbb",
  	"300": "#ed8c8c",
  	"400": "#e46a6a",
  	"500": "#c44848",
  	"600": "#ae3131",
  	"700": "#8d2626",
  	"800": "#641818",
  	"900": "#3c0b0b",
  	"050": "#fde8e8",
  	"025": "#fef9f9"
  };
  var colors$1 = {
  	"neutral-alpha": {
  	"100": "#a8dff538",
  	"200": "#ade3fa42",
  	"300": "#c2e9fc54",
  	"400": "#d2eefa66",
  	"500": "#e2f4fe80",
  	"600": "#eaf7fd94",
  	"700": "#eff9fcab",
  	"800": "#f8fcfec9",
  	"900": "#fcfdfee8",
  	"050": "#b1e7fe21",
  	"025": "#93c0dc12",
  	"000": "#080a0a64"
  },
  	neutral: neutral,
  	"spring-alpha": {
  	"100": "#01cc9969",
  	"200": "#03cc99a1",
  	"300": "#02b689e8",
  	"400": "#019e76f2",
  	"500": "#017f5ffa",
  	"600": "#026b50fc",
  	"700": "#015440fc",
  	"800": "#003a2cfc",
  	"900": "#c4fef0f2",
  	"050": "#0acda033",
  	"025": "#16cd9b0f"
  },
  	spring: spring,
  	"teal-alpha": {
  	"100": "#01887842",
  	"200": "#027b7257",
  	"300": "#006c6e87",
  	"400": "#036a6eab",
  	"500": "#027077e6",
  	"600": "#01555ce3",
  	"700": "#034045e6",
  	"800": "#022529e8",
  	"900": "#000e10ed",
  	"050": "#01937c21",
  	"025": "#37b49b0a"
  },
  	teal: teal,
  	"tan-alpha": {
  	"100": "#3d1f022b",
  	"200": "#371a053d",
  	"300": "#2f120561",
  	"400": "#2a0c0278",
  	"500": "#29090196",
  	"600": "#280901ab",
  	"700": "#280a03bf",
  	"800": "#280802d9",
  	"900": "#170502eb",
  	"050": "#5f4b191a",
  	"025": "#7a583708"
  },
  	tan: tan,
  	"purple-alpha": {
  	"100": "#0b0b7c29",
  	"200": "#00057738",
  	"300": "#0409785e",
  	"400": "#01037675",
  	"500": "#01067796",
  	"600": "#01066eab",
  	"700": "#020552bd",
  	"800": "#010433d1",
  	"900": "#02021be6",
  	"050": "#12128214",
  	"025": "#05056905"
  },
  	purple: purple,
  	"orange-alpha": {
  	"100": "#e34b0340",
  	"200": "#e44d065e",
  	"300": "#e44a029e",
  	"400": "#da4903c9",
  	"500": "#ac3903db",
  	"600": "#872d02de",
  	"700": "#6a2403e6",
  	"800": "#471801ed",
  	"900": "#260d01f5",
  	"050": "#e449001c",
  	"025": "#e669370a"
  },
  	orange: orange,
  	"blue-alpha": {
  	"100": "#02478130",
  	"200": "#01498247",
  	"300": "#03488375",
  	"400": "#02478394",
  	"500": "#034883bf",
  	"600": "#004076d1",
  	"700": "#00325cdb",
  	"800": "#02233ee8",
  	"900": "#011221f2",
  	"050": "#195f911a",
  	"025": "#377a9b08"
  },
  	blue: blue,
  	"green-alpha": {
  	"100": "#03836340",
  	"200": "#01815f59",
  	"300": "#01826196",
  	"400": "#018161c2",
  	"500": "#017f5ffa",
  	"600": "#026b50fc",
  	"700": "#015440fc",
  	"800": "#003a2cfc",
  	"900": "#02221a",
  	"050": "#0582611f",
  	"025": "#379b820a"
  },
  	green: green,
  	"yellow-alpha": {
  	"100": "#e9a40473",
  	"200": "#eb9b0299",
  	"300": "#c97e02c2",
  	"400": "#a56703c9",
  	"500": "#7a4b01d1",
  	"600": "#5f3900d6",
  	"700": "#482c01de",
  	"800": "#2d1b01e6",
  	"900": "#160e02f0",
  	"050": "#efb70740",
  	"025": "#ffd30b17"
  },
  	yellow: yellow,
  	"red-alpha": {
  	"100": "#ea020230",
  	"200": "#e5030345",
  	"300": "#d8050575",
  	"400": "#d1020296",
  	"500": "#ad0101b8",
  	"600": "#9b0101cf",
  	"700": "#7a0303db",
  	"800": "#550101e8",
  	"900": "#340101f5",
  	"050": "#eb19191a",
  	"025": "#de373708"
  },
  	red: red
  };

  var shadows$1 = {
  	
  };

  var fonts$1 = {
  	
  };

  var fontWeights$1 = {
  	"v-regular": "400",
  	"v-medium": "500",
  	"v-semibold": "600",
  	"v-bold": "700"
  };

  var space$1 = {
  	"v-2": "2px",
  	"v-4": "4px",
  	"v-8": "8px",
  	"v-12": "12px",
  	"v-16": "16px",
  	"v-20": "20px",
  	"v-24": "24px",
  	"v-32": "32px",
  	"v-40": "40px",
  	"v-52": "52px",
  	"v-64": "64px",
  	"v-84": "84px",
  	"v-104": "104px",
  	"v-168": "168px",
  	"v-272": "272px",
  	"v-440": "440px",
  	"v-none": "0px"
  };

  var lineHeights$1 = {
  	"v-8": "8px",
  	"v-12": "12px",
  	"v-16": "16px",
  	"v-24": "24px",
  	"v-28": "28px",
  	"v-36": "36px",
  	"v-44": "44px",
  	"v-56": "56px"
  };

  var sizes$1 = {
  	"v-none": "0px",
  	"v-3xs": "2px",
  	"v-2xs": "4px",
  	"v-xs": "8px",
  	"v-sm": "16px",
  	"v-md": "24px",
  	"v-lg": "40px",
  	"v-xl": "64px",
  	"v-2xl": "104px",
  	"v-3xl": "168px",
  	"v-4xl": "272px",
  	"v-5xl": "440px",
  	"v-xs-alt": "12px",
  	"v-sm-alt": "20px",
  	"v-lg-alt": "32px",
  	"v-xl-alt": "52px",
  	"v-2xl-alt": "84px"
  };

  var borders$1 = {
  	
  };

  var fontSizes$1 = {
  	"v-7": "7px",
  	"v-9": "9px",
  	"v-12": "12px",
  	"v-16": "16px",
  	"v-18": "18px",
  	"v-21": "21px",
  	"v-29": "29px",
  	"v-38": "38px",
  	"v-51": "51px"
  };

  var textStyles = {
  	"heading-display": {
  	fontWeight: "700",
  	fontSize: "51px",
  	lineHeight: "56px",
  	fontFamily: "Hanken Grotesk",
  	letterSpacing: "-1px",
  	textIndent: "0",
  	fontVariant: "none",
  	textDecoration: "none"
  },
  	"heading-large": {
  	fontWeight: "700",
  	fontSize: "38px",
  	lineHeight: "44px",
  	fontFamily: "Hanken Grotesk",
  	letterSpacing: "-0.5px",
  	textIndent: "0",
  	fontVariant: "none",
  	textDecoration: "none"
  },
  	"heading-medium": {
  	fontWeight: "700",
  	fontSize: "29px",
  	lineHeight: "36px",
  	fontFamily: "Hanken Grotesk",
  	letterSpacing: "-0.5px",
  	textIndent: "0",
  	fontVariant: "none",
  	textDecoration: "none"
  },
  	"heading-small": {
  	fontWeight: "600",
  	fontSize: "21px",
  	lineHeight: "28px",
  	fontFamily: "Hanken Grotesk",
  	letterSpacing: "-0.2px",
  	textIndent: "0",
  	fontVariant: "none",
  	textDecoration: "none"
  },
  	"body-medium-regular": {
  	fontWeight: "400",
  	fontSize: "16px",
  	lineHeight: "24px",
  	fontFamily: "Hanken Grotesk",
  	letterSpacing: "0px",
  	textIndent: "0",
  	fontVariant: "none",
  	textDecoration: "none"
  },
  	"body-medium-strong": {
  	fontWeight: "600",
  	fontSize: "16px",
  	lineHeight: "24px",
  	fontFamily: "Hanken Grotesk",
  	letterSpacing: "-0.2px",
  	textIndent: "0",
  	fontVariant: "none",
  	textDecoration: "none"
  },
  	"body-small-regular": {
  	fontWeight: "400",
  	fontSize: "12px",
  	lineHeight: "16px",
  	fontFamily: "Hanken Grotesk",
  	letterSpacing: "0px",
  	textIndent: "0",
  	fontVariant: "none",
  	textDecoration: "none"
  },
  	"body-small-strong": {
  	fontWeight: "600",
  	fontSize: "12px",
  	lineHeight: "16px",
  	fontFamily: "Hanken Grotesk",
  	letterSpacing: "0px",
  	textIndent: "0",
  	fontVariant: "none",
  	textDecoration: "none"
  },
  	"data-medium": {
  	fontWeight: "500",
  	fontSize: "9px",
  	lineHeight: "12px",
  	fontFamily: "Hanken Grotesk",
  	letterSpacing: "0.1px",
  	textIndent: "0",
  	fontVariant: "none",
  	textDecoration: "none"
  },
  	"data-small": {
  	fontWeight: "500",
  	fontSize: "7px",
  	lineHeight: "8px",
  	fontFamily: "Hanken Grotesk",
  	letterSpacing: "0.1px",
  	textIndent: "0",
  	fontVariant: "none",
  	textDecoration: "none"
  }
  };

  var borderWidths$1 = {
  	"v-width-thin": "1px",
  	"v-width-thick": "2px"
  };

  var opacity = {
  	"v-100": "1",
  	"v-000": "0",
  	"v-004": "0.04",
  	"v-008": "0.08",
  	"v-012": "0.12",
  	"v-016": "0.16",
  	"v-020": "0.2",
  	"v-024": "0.24",
  	"v-040": "0.4",
  	"v-064": "0.64",
  	"v-092": "0.92"
  };

  var breakpoints = {
  	"v-base": "0em",
  	"v-sm": "30em",
  	"v-md": "48em",
  	"v-lg": "62em",
  	"v-xl": "80em",
  	"v-2xl": "96em"
  };

  var radii = {
  };
  var colors = {
  	"background-base": {
  		"default": "#ffffff",
  		_dark: "#050606"
  	},
  	"background-subtle": {
  		"default": "#fbfaf9",
  		_dark: "#0b1314"
  	},
  	"background-elevated": {
  		"default": "#ffffff",
  		_dark: "#171e21"
  	},
  	"background-disabled": {
  		"default": "#00131738",
  		_dark: "#ade3fa42"
  	},
  	"background-overlay": {
  		"default": "#00131738",
  		_dark: "#080a0a64"
  	},
  	"content-primary": {
  		"default": "#171e22",
  		_dark: "#e5e6e7"
  	},
  	"content-secondary": {
  		"default": "#556065",
  		_dark: "#888f93"
  	},
  	"content-placeholder": {
  		"default": "#6a7378",
  		_dark: "#717a7f"
  	},
  	"content-disabled": {
  		"default": "#0114195e",
  		_dark: "#c2e9fc54"
  	},
  	"border-subtle": {
  		"default": "#efede8",
  		_dark: "#8af6fe21"
  	},
  	"border-interactive": {
  		"default": "#00131738",
  		_dark: "#ade3fa42"
  	},
  	"border-bold": {
  		"default": "#011219ab",
  		_dark: "#eaf7fd94"
  	},
  	"primary-base": {
  		"default": "#068262",
  		_dark: "#0ea17c"
  	},
  	"primary-on-base": {
  		"default": "#f1fcf9",
  		_dark: "#011510"
  	},
  	"primary-bold": {
  		"default": "#033c2e",
  		_dark: "#55dcbb"
  	},
  	"primary-on-bold": {
  		"default": "#f1fcf9",
  		_dark: "#011510"
  	},
  	"primary-subtle": {
  		"default": "#16cd9b0f",
  		_dark: "#0ef3ba24"
  	},
  	"primary-on-subtle": {
  		"default": "#068262",
  		_dark: "#18bb93"
  	},
  	"accent-base": {
  		"default": "#482d28",
  		_dark: "#a5cfcd"
  	},
  	"accent-on-base": {
  		"default": "#fbfaf9",
  		_dark: "#0b1314"
  	},
  	"accent-bold": {
  		"default": "#2a1916",
  		_dark: "#d2ebe7"
  	},
  	"accent-on-bold": {
  		"default": "#fbfaf9",
  		_dark: "#0b1314"
  	},
  	"accent-subtle": {
  		"default": "#5f4b191a",
  		_dark: "#8af6fe21"
  	},
  	"accent-on-subtle": {
  		"default": "#482d28",
  		_dark: "#77afb1"
  	},
  	"info-base": {
  		"default": "#4276a2",
  		_dark: "#4c7da7"
  	},
  	"info-on-base": {
  		"default": "#f9fbfc",
  		_dark: "#050606"
  	},
  	"info-bold": {
  		"default": "#244f73",
  		_dark: "#89a9c5"
  	},
  	"info-on-bold": {
  		"default": "#f9fbfc",
  		_dark: "#050606"
  	},
  	"info-subtle": {
  		"default": "#195f911a",
  		_dark: "#4eacfa2e"
  	},
  	"info-on-subtle": {
  		"default": "#244f73",
  		_dark: "#89a9c5"
  	},
  	"positive-base": {
  		"default": "#068262",
  		_dark: "#0f896a"
  	},
  	"positive-on-base": {
  		"default": "#f7fbfa",
  		_dark: "#050606"
  	},
  	"positive-bold": {
  		"default": "#045642",
  		_dark: "#67b4a0"
  	},
  	"positive-on-bold": {
  		"default": "#f7fbfa",
  		_dark: "#050606"
  	},
  	"positive-subtle": {
  		"default": "#0582611f",
  		_dark: "#0ef3ba24"
  	},
  	"positive-on-subtle": {
  		"default": "#045642",
  		_dark: "#67b4a0"
  	},
  	"warning-base": {
  		"default": "#f3c367",
  		_dark: "#d49b3e"
  	},
  	"warning-on-base": {
  		"default": "#604722",
  		_dark: "#050606"
  	},
  	"warning-bold": {
  		"default": "#795929",
  		_dark: "#f3be5f"
  	},
  	"warning-on-bold": {
  		"default": "#fffbe9",
  		_dark: "#050606"
  	},
  	"warning-subtle": {
  		"default": "#efb70740",
  		_dark: "#f0bb7126"
  	},
  	"warning-on-subtle": {
  		"default": "#604722",
  		_dark: "#d49b3e"
  	},
  	"negative-base": {
  		"default": "#c44848",
  		_dark: "#d04b4b"
  	},
  	"negative-on-base": {
  		"default": "#ffffff",
  		_dark: "#050606"
  	},
  	"negative-bold": {
  		"default": "#8d2626",
  		_dark: "#ed8a8a"
  	},
  	"negative-on-bold": {
  		"default": "#fef9f9",
  		_dark: "#050606"
  	},
  	"negative-subtle": {
  		"default": "#eb19191a",
  		_dark: "#fa2e2e3d"
  	},
  	"negative-on-subtle": {
  		"default": "#8d2626",
  		_dark: "#ed8a8a"
  	},
  	"neutral-base": {
  		"default": "#29373c",
  		_dark: "#a0a7a9"
  	},
  	"neutral-on-base": {
  		"default": "#ffffff",
  		_dark: "#050606"
  	},
  	"neutral-bold": {
  		"default": "#171e22",
  		_dark: "#c4c7c9"
  	},
  	"neutral-on-bold": {
  		"default": "#ffffff",
  		_dark: "#050606"
  	},
  	"neutral-subtle": {
  		"default": "#121e1e14",
  		_dark: "#b1e7fe21"
  	},
  	"neutral-on-subtle": {
  		"default": "#171e22",
  		_dark: "#e5e6e7"
  	},
  	"hover-base-high-emphasis": {
  		"default": "#056c52",
  		_dark: "#18bb93"
  	},
  	"hover-base-medium-emphasis": {
  		"default": "#ded9d4",
  		_dark: "#173335"
  	},
  	"hover-base-low-emphasis": {
  		"default": "#37373708",
  		_dark: "#93c0dc12"
  	},
  	"hover-info-high-emphasis": {
  		"default": "#2e628f",
  		_dark: "#6992b5"
  	},
  	"hover-info-medium-emphasis": {
  		"default": "#cfdce7",
  		_dark: "#173147"
  	},
  	"hover-positive-high-emphasis": {
  		"default": "#056c52",
  		_dark: "#3a9e85"
  	},
  	"hover-positive-medium-emphasis": {
  		"default": "#c0e0d8",
  		_dark: "#023629"
  	},
  	"hover-warning-high-emphasis": {
  		"default": "#d69d3f",
  		_dark: "#b68537"
  	},
  	"hover-warning-medium-emphasis": {
  		"default": "#f5d68e",
  		_dark: "#3b2d18"
  	},
  	"hover-negative-high-emphasis": {
  		"default": "#ae3131",
  		_dark: "#e36767"
  	},
  	"hover-negative-medium-emphasis": {
  		"default": "#fbcfcf",
  		_dark: "#5b1515"
  	},
  	"hover-neutral-high-emphasis": {
  		"default": "#414e53",
  		_dark: "#888f93"
  	},
  	"hover-neutral-medium-emphasis": {
  		"default": "#d7dadb",
  		_dark: "#253136"
  	}
  };
  var shadows = {
  	low: {
  		"default": "0px 0px 4px 0px rgba(72, 45, 40, 0.04), 0px 8px 16px -6px rgba(72, 45, 40, 0.12)",
  		_dark: "0px 0px 4px 0px rgba(5, 6, 6, 0.08), 0px 8px 16px -6px rgba(5, 6, 6, 0.4)"
  	},
  	high: {
  		"default": "0px 0px 8px 0px rgba(72, 45, 40, 0.08), 0px 12px 40px -8px rgba(72, 45, 40, 0.2)",
  		_dark: "0px 0px 8px 0px rgba(5, 6, 6, 0.08), 0px 12px 40px -8px rgba(5, 6, 6, 0.4)"
  	}
  };
  var fonts = {
  };
  var fontWeights = {
  };
  var space = {
  };
  var lineHeights = {
  };
  var sizes = {
  };
  var borders = {
  };
  var borderWidths = {
  };
  var fontSizes = {
  };
  var semanticTokens = {
  	radii: radii,
  	colors: colors,
  	shadows: shadows,
  	fonts: fonts,
  	fontWeights: fontWeights,
  	space: space,
  	lineHeights: lineHeights,
  	sizes: sizes,
  	borders: borders,
  	borderWidths: borderWidths,
  	fontSizes: fontSizes
  };

  var Text = {
  	sizes: {
  		"body-medium-regular": {
  			fontWeight: "400",
  			fontSize: "16px",
  			lineHeight: "24px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "0px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"body-medium-strong": {
  			fontWeight: "600",
  			fontSize: "16px",
  			lineHeight: "24px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "-0.2px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"body-small-regular": {
  			fontWeight: "400",
  			fontSize: "12px",
  			lineHeight: "16px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "0px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"body-small-strong": {
  			fontWeight: "600",
  			fontSize: "12px",
  			lineHeight: "16px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "0px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"data-medium": {
  			fontWeight: "500",
  			fontSize: "9px",
  			lineHeight: "12px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "0.1px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"data-small": {
  			fontWeight: "500",
  			fontSize: "7px",
  			lineHeight: "8px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "0.1px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		}
  	}
  };
  var Heading = {
  	sizes: {
  		"heading-display": {
  			fontWeight: "700",
  			fontSize: "51px",
  			lineHeight: "56px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "-1px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"heading-large": {
  			fontWeight: "700",
  			fontSize: "38px",
  			lineHeight: "44px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "-0.5px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"heading-medium": {
  			fontWeight: "700",
  			fontSize: "29px",
  			lineHeight: "36px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "-0.5px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"heading-small": {
  			fontWeight: "600",
  			fontSize: "21px",
  			lineHeight: "28px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "-0.2px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		}
  	}
  };
  var FormLabel = {
  	sizes: {
  		"heading-display": {
  			fontWeight: "700",
  			fontSize: "51px",
  			lineHeight: "56px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "-1px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"heading-large": {
  			fontWeight: "700",
  			fontSize: "38px",
  			lineHeight: "44px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "-0.5px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"heading-medium": {
  			fontWeight: "700",
  			fontSize: "29px",
  			lineHeight: "36px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "-0.5px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"heading-small": {
  			fontWeight: "600",
  			fontSize: "21px",
  			lineHeight: "28px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "-0.2px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"body-medium-regular": {
  			fontWeight: "400",
  			fontSize: "16px",
  			lineHeight: "24px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "0px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"body-medium-strong": {
  			fontWeight: "600",
  			fontSize: "16px",
  			lineHeight: "24px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "-0.2px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"body-small-regular": {
  			fontWeight: "400",
  			fontSize: "12px",
  			lineHeight: "16px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "0px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"body-small-strong": {
  			fontWeight: "600",
  			fontSize: "12px",
  			lineHeight: "16px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "0px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"data-medium": {
  			fontWeight: "500",
  			fontSize: "9px",
  			lineHeight: "12px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "0.1px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		},
  		"data-small": {
  			fontWeight: "500",
  			fontSize: "7px",
  			lineHeight: "8px",
  			fontFamily: "Hanken Grotesk",
  			letterSpacing: "0.1px",
  			textIndent: "0",
  			fontVariant: "none",
  			textDecoration: "none"
  		}
  	}
  };
  var components = {
  	Text: Text,
  	Heading: Heading,
  	FormLabel: FormLabel
  };

  var mx$1 = {
      radii: radii$1,
      colors: colors$1,
      shadows: shadows$1,
      fonts: fonts$1,
      fontWeights: fontWeights$1,
      space: space$1,
      lineHeights: lineHeights$1,
      sizes: sizes$1,
      borders: borders$1,
      fontSizes: fontSizes$1,
      textStyles: textStyles,
      borderWidths: borderWidths$1,
      opacity: opacity,
      breakpoints: breakpoints,
      semanticTokens: semanticTokens,
      components: components,
  };

  var theme = {
      cgx: mx$1,
      mx: mx$1,
  };

  var cgx = theme.cgx, mx = theme.mx;

  exports.cgx = cgx;
  exports.default = theme;
  exports.mx = mx;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
